import React, { useContext, useState, useCallback, useRef } from 'react';
import { Container, Table, Button, Row, Col, Modal, Form } from 'react-bootstrap';
import { IdentityContext } from '../../../../../../context/identity-context';
import { UploadModal, CreateReportModal, CommentModal, ExcelPreviewModal } from './components/modal/modal';
import ReportsService from '../../../../../../services/reports-service';
import * as XLSX from 'xlsx';

const EventBasedReportContainer = ({ items, handleCheckboxChange }) => {
  const reportService = new ReportsService();
  const { user } = useContext(IdentityContext);

  const [createModalShow, setCreateModalShow] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [uploadModalData, setUploadModalData] = useState({
    show: false,
    report: null,
    item: null,
    file: null,
  });
  const [commentModalData, setCommentModalData] = useState({ show: false, comment: '' });
  const [formData, setFormData] = useState({
    reportTitle: '',
    issuer: '',
    isin: '',
    file: '',
  });
  const createModalRef = useRef(null);
  const [submissionModalShow, setSubmissionModalShow] = useState(false);
  const [submissionMessage, setSubmissionMessage] = useState('');

  // New search term state
  const [searchTerm, setSearchTerm] = useState('');

  // New states for Excel preview modal
  const [excelPreviewData, setExcelPreviewData] = useState([]);
  const [showExcelPreviewModal, setShowExcelPreviewModal] = useState(false);

  const handleCreateReport = () => {
    setFormData({ reportTitle: '', issuer: '', isin: '', file: '' });
    setCreateModalShow(true);
  };

  const handleCreateModalClose = () => {
    setCreateModalShow(false);
  };

  const handleCloseSubmissionModal = () => {
    setSubmissionModalShow(false);
    window.location.reload();
  };

  const handleSubmitCorrected = async () => {
    const checkedReports = items.filter(item => selectedItems.includes(item.id));
    console.log('Checked reports:', checkedReports);

    const totalReports = checkedReports.length;
    const makerName = user.attributes['custom:display_name'];

    const submissionPromises = checkedReports.map(report => {
      const options = { 
        issuer: report.securityIssuer,
        bpId: report.bpId || '',
        holder: report.holder || ''
      };
      const reportTitleLower = report.reportTitle.toLowerCase();

      if (reportTitleLower.includes('bir')) {
        const reportDate = {
          dateFrom: report.dateFrom,
          dateTo: report.dateTo,
          paymentDate: ''
        };
        return reportService.makerSubmitEventBasedReport(
          report.isin,
          report.reportTitle,
          options,
          reportDate,
          null,
          makerName
        );
      } else if (reportTitleLower.includes('closure')) {
        const reportDate = {
          dateFrom: '',
          dateTo: '',
          paymentDate: report.paymentDate,
          maturityDate: report.maturityDate
        };
        return reportService.makerSubmitEventBasedReport(
          report.isin,
          report.reportTitle,
          options,
          reportDate,
          null,
          makerName
        );
      } else if (reportTitleLower.includes('consent')){
        const reportDate = {
          dateFrom: '',
          dateTo: '',
          paymentDate: report.paymentDate
        };
        const options = {
          address: report.address,
          issuer: report.securityIssuer,
          amount: report.amount
        }
        return reportService.makerSubmitEventBasedReport(
          report.isin,
          report.reportTitle,
          options,
          reportDate,
          null,
          makerName
        );
      }
      else if (reportTitleLower.includes('credit')){
        return reportService.makerSubmitEventBasedCreditLetterReport(
          report.isin,
          report.reportTitle,
          report.securityIssuer,
          report.paymentDate,
          report.address,
          makerName
        );
      }
      else {
        return Promise.reject('Unknown report type');
      }
    });

    Promise.allSettled(submissionPromises)
      .then(results => {
        const successCount = results.filter(r => r.status === "fulfilled").length;
        setSubmissionMessage(`Successfully sent ${successCount} of ${totalReports} reports`);
        setSubmissionModalShow(true);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      });
  };

  const handleSubmitReport = (report) => {
    console.log('Submitted report:', report);
    const makerName = user.attributes['custom:display_name'];
    
    if(report.reportTitle === 'Credit Letter'){
      reportService.makerSubmitEventBasedCreditLetterReport(
        report.isin,
        report.reportTitle,
        report.issuer,
        report.paymentDate,
        report.address,
        makerName
      );
      console.log('rest')
      setCreateModalShow(false);
      window.location.reload();
    }
    else
    {
      const reader = new FileReader();
      reader.readAsDataURL(report.file);
      reader.onloadend = async () => {
        const base64File = reader.result.split(",").pop();
        try {
          if (report.reportTitle === 'Consent Solicitation Entitlement Report Excel') {
            console.log(report.issuer);
            await reportService.makerSubmitEventBasedConsentSolicitationReport(
              report.isin,
              report.reportTitle,
              report.issuer,
              report.address,
              report.paymentDate,
              report.amount,
              base64File,
              makerName,
              report.file.name
            );
          } else {
            const options = { 
              issuer: report.issuer,
              bpId: report.bpId || '',
              holder: report.holder || '' 
            };
            const reportDate = {
              dateFrom: report.dateFrom,
              dateTo: report.dateTo,
              paymentDate: report.paymentDate ? report.paymentDate : '',
              maturityDate: report.maturityDate
            };
            await reportService.makerSubmitEventBasedReport(
              report.isin,
              report.reportTitle,
              options,
              reportDate,
              base64File,
              makerName,
              report.file.name
            );
          }
          setCreateModalShow(false);
          window.location.reload();
        } catch (error) {
          console.error('Error sending report:', error);
        }
      };
      reader.onerror = function (error) {
        throw error;
      };
    }
  };

  const handleUploadModalOpen = useCallback((item) => {
    setUploadModalData({ show: true, report: null, item });
  }, []);

  const handleUploadModalClose = useCallback(() => {
    setUploadModalData({ show: false });
  }, []);

  const getEmbedUrl = (url) => {
    try {
      const urlObj = new URL(url);
      // Additional processing can be added here if needed
    } catch (e) {
      console.log(e);
    }
    return url;
  };

  const areReportsSelected = selectedItems.length > 0;

  const handlePreviewClick = async (report) => {
    try {
      let s3Prefix = '';
      if (
        report.reportTitle.startsWith('Closure of Registry Service') ||
        report.reportTitle.startsWith('Consent Solicitation Entitlement') ||
        report.reportTitle.startsWith('Credit Letter')
      ) {
        // For Closure or Consent Solicitation, use paymentDate in the prefix.
        s3Prefix = `Ad-hoc Reports/${report.isin}/${report.reportTitle}/${report.paymentDate}/`;
      } else {
        // For BIR 2306, use holder and dateFrom+dateTo.
        s3Prefix = `Ad-hoc Reports/${report.isin}/${report.reportTitle}/${report.bpId}/${report.holder}/${report.dateFrom + report.dateTo}/`;
      }
      const response = await reportService.retrieveEventBasedReport(s3Prefix);
      const fileURL = response.fileURL;
      const urlObj = new URL(fileURL);
      
      console.log(urlObj.pathname);
      // Check if the report is an Excel file based on its title
      if (report.reportTitle.startsWith('Consent Solicitation Entitlement Excel') ||
        urlObj.pathname.toLowerCase().endsWith('.xlsx')) {
        const fileResponse = await fetch(fileURL);
        if (!fileResponse.ok) throw new Error('Network response was not ok');
        const blob = await fileResponse.blob();
        const arrayBuffer = await blob.arrayBuffer();
        const workbook = XLSX.read(arrayBuffer, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
        const spreadsheetData = jsonData.map(row => row.map(cell => ({ value: cell, readOnly: true })));
        setExcelPreviewData(spreadsheetData);
        setShowExcelPreviewModal(true);
      } else {
        const embedUrl = getEmbedUrl(fileURL);
        const newWindow = window.open(embedUrl, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null;
      }
    } catch (error) {
      console.error('Error fetching report preview:', error.message);
    }
  };  

  const handleLocalCheckboxChange = (id) => (e) => {
    if (e.target.checked) {
      setSelectedItems((prev) => [...prev, id]);
    } else {
      setSelectedItems((prev) => prev.filter((itemId) => itemId !== id));
    }
    if (handleCheckboxChange) {
      handleCheckboxChange(id);
    }
  };

  const handleDownloadClick = async (report) => {
    try {
      let s3Prefix = '';
      if (
        report.reportTitle.startsWith('Closure of Registry Service') ||
        report.reportTitle.startsWith('Consent Solicitation Entitlement') ||
        report.reportTitle.startsWith('Credit Letter')
      ) {
        s3Prefix = `Ad-hoc Reports/${report.isin}/${report.reportTitle}/${report.paymentDate}/`;
      } else {
        s3Prefix = `Ad-hoc Reports/${report.isin}/${report.reportTitle}/${report.bpId}/${report.holder}/${report.dateFrom + report.dateTo}/`;
      }
      const response = await reportService.retrieveEventBasedReport(s3Prefix);
      
      if (response && response.fileURL) {
        const url = response.fileURL;
        const filename = response.fileName || url.substring(url.lastIndexOf('/') + 1);
  
        const fileResponse = await fetch(url);
        if (!fileResponse.ok) throw new Error('Network response was not ok');
  
        const blob = await fileResponse.blob();
        const objectUrl = window.URL.createObjectURL(blob);
  
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = filename;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(objectUrl);
      } else {
        console.error('Download: No file URL returned');
      }
    } catch (error) {
      console.error('Error fetching report download:', error);
    }
  };

  const handleUploadClick = async (report) => {
    // Existing functionality for upload (if any) goes here.
  };

  // Create a derived filtered list from the search term.
  const filteredItems = items.filter(item => {
    const searchableText = `
      ${item.reportTitle} 
      ${item.issuer} 
      ${item.isin} 
      ${item.status} 
      ${item.bpId || ''} 
      ${item.maturityDate || ''} 
      ${item.holder || ''}
    `.toLowerCase();
    return searchableText.includes(searchTerm.toLowerCase());
  });

  return (
    <Container
      fluid
      className="report-container event-based-report-container"
      style={{
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '37.5rem' // 37.5rem is equivalent to 600px
      }}
    >
      {/* Search bar added at the top */}
      <Row className="mb-3">
        <Col md={12}>
          <Form.Control
            type="text"
            placeholder="Search reports..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Col>
      </Row>
      <Row className="align-items-center mb-3">
        <Col>
          <h5>Event-Based Container</h5>
        </Col>
        <Col className="text-right">
          <Button variant="primary" onClick={handleCreateReport}>
            Create Report
          </Button>
        </Col>
      </Row>
      
      <div style={{ flex: 1, overflowY: 'auto' }}>
        <Table bordered>
          <thead>
            <tr>
              <th></th>
              <th>Report Name</th>
              <th>Issuer</th>
              <th>ISIN</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredItems && filteredItems.length > 0 ? (
              filteredItems.map((item, index) => (
                <tr key={index}>
                  <td>
                    <label style={{ display: 'flex', alignItems: 'center' }}>
                      <input
                        type="checkbox"
                        style={{ marginRight: '8px' }}
                        disabled={!(item.status === 'Report Available' || item.status === 'For Adjustment')}
                        checked={selectedItems.includes(item.id)}
                        onChange={handleLocalCheckboxChange(item.id)}
                      />
                    </label>
                  </td>
                  <td>
                    {item.reportTitle === 'BIR 2306 Request Letter' ? (
                      <>
                        {'BIR 2306 Request Letter'}<br />
                        {`BPID: ${item.bpId || ''}`}<br />
                        {`Holder Name: ${item.holder || ''}`}
                      </>
                    ) : item.reportTitle === 'Closure of Registry Service / Payment Account' ? (
                      <>
                        {'Closure of Registry Service / Payment Account'}<br />
                        {`Maturity Date: ${item.maturityDate || ''}`}
                      </>
                    ) : item.reportTitle === 'Credit Letter' ? (
                      <>
                        {'Credit Letter'}<br />
                        {`Payment Date: ${item.paymentDate || ''}`}
                      </>
                    ) : (
                      item.reportTitle
                    )}
                  </td>
                  <td>{item.securityIssuer}</td>
                  <td>{item.isin}</td>
                  <td>
                    {item.status}
                    {item.comment && (
                      <span
                        style={{ cursor: 'pointer', marginLeft: '5px' }}
                        onClick={() => setCommentModalData({ show: true, comment: item.comment })}
                      >
                        &#9865;
                      </span>
                    )}
                  </td>
                  <td>
                    {item.status === 'For Adjustment' && (
                      <Button variant="primary" className="action-button" onClick={() => handleUploadModalOpen(item)}>
                        Upload
                      </Button>
                    )}
                    {item.status !== 'For Generation' && (
                      <>
                        <Button variant="primary" className="action-button" onClick={() => handlePreviewClick(item)}>
                          Preview
                        </Button>
                        <Button variant="primary" className="action-button" onClick={() => handleDownloadClick(item)}>
                          Download
                        </Button>
                      </>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  No Reports
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <Row>
        <Col xs={12}>
          <div className="actions-container">
            <Button
              onClick={handleSubmitCorrected}
              className="submit-button"
              variant="primary"
              disabled={!areReportsSelected}
              aria-disabled={!areReportsSelected}
            >
              Submit Corrected Reports
            </Button>
          </div>
        </Col>
      </Row>
      
      <CreateReportModal
        ref={createModalRef}
        show={createModalShow}
        onClose={handleCreateModalClose}
        onSubmit={handleSubmitReport}
        formData={formData}
        setFormData={setFormData}
      />

      <UploadModal
        report={uploadModalData.report}
        item={uploadModalData.item}
        show={uploadModalData.show}
        onClose={handleUploadModalClose}
      />

      <Modal show={submissionModalShow} onHide={handleCloseSubmissionModal}>
        <Modal.Header closeButton>
          <Modal.Title>Submission Results</Modal.Title>
        </Modal.Header>
        <Modal.Body>{submissionMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCloseSubmissionModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <CommentModal
        show={commentModalData.show}
        comment={commentModalData.comment}
        onClose={() => setCommentModalData({ show: false, comment: '' })}
      />

      {/* Excel Preview Modal */}
      {showExcelPreviewModal && (
        <ExcelPreviewModal
          show={showExcelPreviewModal}
          data={excelPreviewData}
          onClose={() => setShowExcelPreviewModal(false)}
        />
      )}
    </Container>
  );
};

export default EventBasedReportContainer;
